(() => {
  const root = document.documentElement;
  root.classList.add('sk-js-ready');

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealAll = () => {
    document.querySelectorAll('.sk-animate').forEach((el) => el.classList.add('is-visible'));
  };

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  const observeAll = () => {
    document.querySelectorAll('.sk-animate:not(.is-visible)').forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll, { once: true });
  } else {
    observeAll();
  }

  document.addEventListener('shopify:section:load', observeAll);
})();

// Header mobile menu: backdrop click, link click, and Escape close
(() => {
  function initHeaderMobile() {
    document.querySelectorAll('.sk-header__mobile').forEach((details) => {
      if (details._skHeaderInit) return;
      details._skHeaderInit = true;

      const close = () => {
        if (details.open) details.open = false;
      };

      const backdrop = details.querySelector('[data-sk-header-backdrop]');
      if (backdrop) backdrop.addEventListener('click', close);

      details.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && details.open) close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMobile, { once: true });
  } else {
    initHeaderMobile();
  }

  document.addEventListener('shopify:section:load', initHeaderMobile);
})();

// Video testimonial dialog
(() => {
  function closeDialog(dialog) {
    const video = dialog.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    dialog.close();
  }

  function initVideoDialogs() {
    document.querySelectorAll('[data-sk-video-trigger]').forEach((trigger) => {
      if (trigger._skVideoInit) return;
      trigger._skVideoInit = true;

      const dialogId = trigger.dataset.skVideoTrigger;
      const dialog = document.querySelector(`[data-sk-video-dialog="${dialogId}"]`);
      if (!dialog) return;

      trigger.addEventListener('click', () => {
        dialog.showModal();
        const video = dialog.querySelector('video');
        if (video) video.play().catch(() => {});
      });

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) closeDialog(dialog);
      });

      dialog.querySelectorAll('[data-sk-video-close]').forEach((btn) => {
        btn.addEventListener('click', () => closeDialog(dialog));
      });

      dialog.addEventListener('cancel', () => closeDialog(dialog));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoDialogs, { once: true });
  } else {
    initVideoDialogs();
  }

  document.addEventListener('shopify:section:load', initVideoDialogs);
})();
